<template>
  <v-container class="insurance-quote-page">
    <v-row no-gutters>
      <v-col cols="12" sm="1">
        <router-link :to="{ name: 'InsuranceQuestions' }" class="back-arrow"
          ><v-icon large color="mid-grey" class="mt-1">{{
            icons.mdiArrowLeft
          }}</v-icon></router-link
        >
      </v-col>
      <v-col cols="12" sm="11">
        <h1 class="mb-2">How would you like to pay for your premium?</h1>
      </v-col>
    </v-row>

    <div v-if="loading" class="text-center">
      <v-progress-circular indeterminate color="primary" />
    </div>

    <div v-else class="text-center">
      <v-row>
        <v-col cols="12">
          <h1>
            <span class="secondary-highlighted"
              >R{{ totalCover | currency }}<span> cover</span></span
            >
          </h1>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12">
          <h2>for</h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6" offset-md="3">
          <v-radio-group
            v-model="subscriptionType"
            row
            class="insurance-premium-radio-group"
            active-class="insurance-premium-active"
          >
            <v-row>
              <v-col cols="12" sm="6">
                <v-radio
                  class="insurance-premium float-sm-right"
                  value="MONTHLY"
                  color="primary"
                >
                  <template #label>
                    <div class="insurance-premium-label">
                      <span
                        >R{{ testator.insurance.monthlyPremiumQuoted }}</span
                      >
                      monthly premium
                    </div>
                  </template>
                </v-radio>
              </v-col>
              <v-col cols="12" sm="6">
                <v-radio
                  class="insurance-premium float-sm-left"
                  value="ANNUALLY"
                  color="primary"
                >
                  <template #label>
                    <div class="insurance-premium-label">
                      <span>R{{ testator.insurance.yearlyPremiumQuoted }}</span>
                      yearly premium
                    </div>
                  </template>
                </v-radio>
              </v-col>
            </v-row>
          </v-radio-group>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          lg="10"
          xl="8"
          offset-lg="1"
          offset-xl="2"
          class="text-left"
        >
          <h2>
            Before you proceed, there is some important information you need to
            take note of:
          </h2>
          <p>
            Unfortunately, no benefit can be paid if the death results from the
            specific behaviors, waiting periods or events listed here;
          </p>
          <h2>Exclusions</h2>
          <p>
            Old Mutual Alternative Risk Transfer Limited will not be obliged to
            make payment in respect of any condition or event arising directly
            or indirectly from or traceable to;
          </p>
          <h4>Suicide or Suicide Attempt</h4>
          <ul>
            <li>
              If the Life Assured dies, whether sane or insane, by his own
              intentional act within 24 months of the Commencement of Insurance
              or date of any reinstatement no claim shall be considered or paid
              and all premiums paid to date shall be forfeited.
            </li>
            <li>
              In the event of any increase in the amount of any benefit due to
              any subsequent written request the aforementioned stipulation
              shall apply for a further 24 months from the date of such increase
              in respect of the increased portion of the benefit.
            </li>
          </ul>

          <h4>Hazardous Sport /Activity</h4>
          <p>
            The Life Assured participating in a Hazardous Sport / Activity as
            listed;
          </p>
          <p>
            “Hazardous Sport / Activity” include but are not limited to
            participation in the following sports: aviation sports, paragliding,
            underwater diving necessitating the use of an artificial breathing
            apparatus, hang-gliding, hunting, spear-fishing, rock-climbing or
            mountaineering necessitating the use of ropes and/or guides, free
            climbing, open water swimming, micro-lighting, motorboat racing,
            motor racing, motor-cycle racing, sky diving/parachuting, target
            shooting, acrobatic flying, parasailing, go-carting, drag-racing,
            rally driving, bungee jumping, winter sports involving snow or ice,
            or racing other than on foot or bicycle.
          </p>

          <h4>General Exclusions</h4>
          <ul>
            <li>
              Driving while the concentration of alcohol in your blood exceeds
              the legal limit or whilst the Life Assured is under the influence
              of drugs and/or medication having a narcotic effect, unless
              prescribed by a registered medical practitioner and used as
              prescribed.
            </li>
            <li>The Life Assured committing any breach of criminal law.</li>
            <li>
              Participation in any terrorist activity, war, invasion,
              hostilities or warlike operations, civil war, revolution,
              rebellion, insurrection, military or unsurped power, martial law,
              strike, riot or civil commotion.
            </li>
            <li>
              Atomic, biological or chemical weapons as well as radioactive,
              biological or chemical substances.
            </li>
            <li>
              Attacks or intentional disruptions of operating sites or other
              fixed installations, premises or mobile equipment leading to
              release of radioactivity or atomic, biological or chemical
              warefare agents.
            </li>
            <li>
              Sudden release of nuclear energy, nuclear radiation or radioactive
              contamination.
            </li>
          </ul>

          <h2>Waiting periods</h2>
          <ul>
            <li>
              From the Commencement of Insurance, there is a three (3) month
              waiting period for claims due to death by Natural Causes, for all
              Life Assureds under the Policy.
            </li>
            <li>
              There is no waiting period in respect of any Accidental Death
              Claim.
            </li>
            <li>
              In the event of a Life Assured increasing the Sum Assured for any
              person insured under the Policy, from the date of such increase in
              cover, a three (3) month waiting period will apply only to the
              amount by which the benefit increased.
            </li>
            <li>
              Where any premium payment is missed and thereafter paid, the part
              of the waiting period not completed at the point when the premium
              was not paid, will apply from the date the premium is paid.
            </li>
            <li>
              Where a Policy is reinstated, a new waiting period will start from
              the re-instatement date of cover.
            </li>
          </ul>

          <h2>Payment benefits</h2>
          <ol>
            <li>
              In terms of any Accidental Death Claim the full Sum Assured will
              be paid immediately provided the policy for the Life Assured is in
              force.
            </li>
            <li>
              In terms of any claim for death due to Natural Causes the
              following levels of benefits will apply from the Commencement of
              Insurance, and any reinstatement and any increase in Sum Assured;
              <ul>
                <li>
                  First 3 months: - 0% of the Sum Assured (waiting period)
                </li>
                <li>3 months to 6 months: - 50% of the Sum Assured</li>
                <li>6 months to 12 months: - 80% of the Sum Assured</li>
                <li>12 months onwards: - 100% of the Sum Assured</li>
              </ul>
            </li>
          </ol>

          <p class="mt-8">
            Link to
            <a :href="whitelabel.insuranceTermsPdfLocation" target="_blank"
              >full terms and conditions.</a
            >
          </p>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12" md="6" offset-md="3" class="mb-5">
          <h2 class="mb-5">Illustrative premiums</h2>
          <v-simple-table class="user-view-table">
            <thead>
              <tr>
                <th>Year</th>
                <th>Premium</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in ageEscalationPremium" :key="item.year">
                <td>{{ item.year }}</td>
                <td v-if="isMonthlySubscription">
                  R {{ item.totalPremiumMonthly / 100 }}
                </td>
                <td v-else>R {{ item.totalPremiumYearly / 100 }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h4>
            By clicking next I confirm that I have read, and agree, to the terms
            stated above.
          </h4>
        </v-col>
      </v-row>

      <div class="my-8">
        <v-btn
          :loading="buttonLoading && yesButtonLoading"
          rounded
          depressed
          large
          color="primary"
          @click="wantsCover()"
        >
          <span>Next</span><v-icon small>{{ icons.mdiArrowRight }}</v-icon>
        </v-btn>

        <v-btn
          :loading="buttonLoading && noButtonLoading"
          rounded
          depressed
          large
          color="grey"
          @click="doesntWantCover()"
        >
          No thanks, I'll skip to my will
        </v-btn>
      </div>
    </div>

    <ErrorSnackbar v-model="showError" />
  </v-container>
</template>

<script>
  import { INSURANCE_QUOTE_MUTATION } from '../../constants/graphql/insurance';
  import { TESTATOR_QUERY } from '../../constants/graphql/testators';
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';

  export default {
    name: 'InsuranceQuote',
    components: {
      ErrorSnackbar,
    },
    props: {
      testator: {
        required: true,
        type: Object,
      },
      buttonLoading: {
        default: false,
        type: Boolean,
      },
    },
    data() {
      return {
        insuranceQuote: null,
        subscriptionType: null,
        showError: false,
        loading: true,
        noButtonLoading: false,
        yesButtonLoading: false,
        publicPath: process.env.BASE_URL,
      };
    },
    computed: {
      totalCover() {
        return this.testator.insurance.rootSumAssured / 100;
      },
      isMonthlySubscription() {
        return this.subscriptionType == 'MONTHLY';
      },
      ageEscalationPremium() {
        return this.isMonthlySubscription
          ? this.insuranceQuote.monthlyQuote.ageEscalationPremium
          : this.insuranceQuote.yearlyQuote.ageEscalationPremium;
      },
    },
    created() {
      this.subscriptionType = this.testator.insurance.subscriptionType
        ? JSON.parse(JSON.stringify(this.testator.insurance.subscriptionType))
        : 'ANNUALLY';
      this.getInsuranceQuote();
    },
    methods: {
      getInsuranceQuote() {
        const insuranceId = this.testator.insurance.id;

        this.$apollo
          .mutate({
            mutation: INSURANCE_QUOTE_MUTATION,
            variables: {
              insuranceId,
            },
            update: (cache, { data: { insuranceQuote } }) => {
              this.updateCacheAfterInsuranceQuote(cache, insuranceQuote);
            },
          })
          .then(response => {
            this.insuranceQuote = response.data.insuranceQuote;
            this.loading = false;
          })
          .catch(error => {
            this.showError = true;
            throw error;
          });
      },
      updateCacheAfterInsuranceQuote(cache, insuranceQuote) {
        const query = {
          query: TESTATOR_QUERY,
          variables: { id: this.testatorId },
        };
        const data = cache.readQuery(query);

        data.testator.insurance = insuranceQuote.insurance;

        cache.writeQuery({ ...query, data: data });
      },
      wantsCover() {
        this.yesButtonLoading = true;

        const insuranceInputDetails = {
          testatorId: this.testatorId,
          subscriptionType: this.subscriptionType,
        };
        const params = {
          insuranceInputDetails: insuranceInputDetails,
          redirectLocation: 'InsuranceImportantInfo',
        };
        this.$emit('updateInsurance', params);
      },
      doesntWantCover() {
        this.noButtonLoading = false;

        const insuranceInputDetails = {
          testatorId: this.testatorId,
          skipInsurance: true,
        };
        const params = {
          insuranceInputDetails: insuranceInputDetails,
          redirectLocation: 'PaymentPlanPage',
        };
        this.$emit('updateInsurance', params);
      },
    },
  };
</script>

<style lang="scss">
  .insurance-quote-page {
    .secondary-highlighted {
      display: inline-block;
      padding: 8px 15px;

      span {
        display: inline-block;
        font-size: 22px;
        margin-left: 10px;
        padding-bottom: 5px;
        vertical-align: middle;
      }
    }

    h2 {
      margin-top: 20px;
    }

    h4 {
      margin-top: 10px;
    }

    .insurance-premium-radio-group {
      .v-input__control,
      .v-input--radio-group__input {
        width: 100%;
      }

      .insurance-premium {
        border: solid 2px var(--v-grey-base);
        border-radius: 6px;
        max-width: 400px;
        padding-left: 20px;

        .insurance-premium-label {
          padding: 25px 20px 25px 10px;
          color: var(--v-font-color-base);
          span {
            font-weight: bold;
            font-size: 20px;
          }
        }
      }

      .insurance-premium-active {
        border: solid 2px var(--v-primary-base);
        background-color: rgba(58, 222, 180, 0.05);
      }
    }
  }
</style>
